module.exports = __webpack_public_path__ + "img/shipinliaotian.e3844026.png";